import React, { useRef, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
// Import at the top of your file
import InfoIcon from "@mui/icons-material/Info";

import { useSelector } from "react-redux";
import details from "../../assets/icon/details.png";
import CandidateInformation from "../MyFranchise/candidateInformation";
import { getAllEnquiriesById } from "./consultantAPI";
import Heading from "../../common/Heading";
const Enquiries = ({ backEnquire, enquiries }) => {
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );
  const [enquiry, setenquiry] = useState();
  const [totalEnquiry, setTotalEnquiry] = useState();
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const [modalData, setModalData] = useState();
  const [open, setOpen] = useState(false);

  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));

  const getAllApplieded = async (param) => {
    const payload = { billerId: billerId || userDetail?.userMasterId };

    getAllEnquiriesById(payload, (data) => {
      console.log("enquiries ", data);
      const datalist = data.data;
      setenquiry(datalist.data.list);
      setTotalEnquiry(datalist.data.totalRecords);
    });
  };

  useEffect(() => {
    getAllApplieded();
  }, []);

   const tableGrid = {
     display: "grid",
     gridTemplateColumns: {
       lg: `
    minmax(140px, 1fr)  
    minmax(220px, 2fr)     
    minmax(160px, 1.5fr)   
    minmax(220px, 1.5fr)    
    minmax(260px, 2fr)     
    minmax(90px, 1fr)     
  `,
       md: `
  minmax(120px, 1.2fr)
  minmax(200px, 2fr)
  minmax(140px, 1.5fr)
  minmax(200px, 2fr)
  minmax(240px, 2fr)
  minmax(80px, 1fr)
  `,
       sm: `
  minmax(100px, 1.2fr)
  minmax(180px, 2fr)
  minmax(120px, 1.5fr)
  minmax(180px, 2fr)
  minmax(220px, 2fr)
  minmax(70px, 1fr)
  `,
       xs: `
  minmax(80px, 1.2fr)
  minmax(150px, 2fr)
  minmax(100px, 1.5fr)
  minmax(150px, 2fr)
  minmax(200px, 2fr)
  minmax(60px, 1fr)
  `,
     },
     alignItems: "center",
     columnGap: "12px",
   };

  const labelStyle1 = {
    // fontWeight: 600,
    // color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "14px", lg: "15px" },
    // whiteSpace: "nowrap",
  };
  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={{ xs: 2, sm: 4 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Heading name="Consultant Enquiries" />

        {/* <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px 15px",
              mt: "10px",
              borderRadius: "5px",
              color: "#01008B",
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              fontSize={{
                xs: "12px",
                sm: "13px",
                md: "20px",
              }}
            >
              Consultant Enquiries
            </Typography>
          </Grid>
        </Grid> */}

        <Grid container>
          <Grid item xs={12} sx={{ p: 0 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <Typography
                sx={{
                  color: "#01008B",
                  fontSize: {
                    xs: "13px",
                    sm: "16px",
                    md: "20px",
                  },
                  fontWeight: 500,
                }}
              >
                Total Enquiries -{totalEnquiry}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            backgroundColor: "white",
            px: 1,
            py: 2,
            mt: 2,
            borderRadius: "12px",
            overflow: "auto",
            height: "75vh",
          }}
        >
          <Box
            sx={{
              minWidth: {
                lg: "1350px",
                md: "1200px",
                sm: "1200px",
                xs: "1100px",
              },
            }}
          >
            {/* HEADER */}
            <Box
              sx={{
                ...tableGrid,
                borderBottom: "1.5px solid black",
                p: "10px",
              }}
            >
              <Box sx={{ ...labelStyle1, color: "#01008B", fontWeight: 500 }}>
                Date of Enquiry
              </Box>

              <Box
                sx={{
                  ...labelStyle1,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Candidate Name
              </Box>

              <Box
                sx={{
                  ...labelStyle1,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Mobile No.
              </Box>

              <Box
                sx={{
                  ...labelStyle1,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Email Id
              </Box>

              <Box
                sx={{
                  ...labelStyle1,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Address
              </Box>
              <Box
                sx={{
                  ...labelStyle1,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              ></Box>

              <Box />
            </Box>

            {/* DATA ROW */}
            {enquiry?.map((enq, index) => {
              return (
                <Box
                  sx={{
                    ...tableGrid,
                    backgroundColor: "#E8E8FF",
                    borderRadius: "8px",
                    mt: 1,
                    mb: 1,
                    p: 1,

                    // width: "fit-content",
                  }}
                >
                  <Box sx={{ ...labelStyle1, px: 2, fontWeight: "medium" }}>
                    {formatDate(enq?.appliedDate) || "-"}
                  </Box>

                  <Box
                    sx={{
                      ...labelStyle1,
                      textAlign: "center",
                      fontWeight: "medium",
                    }}
                  >
                    {enq?.userName || "-"}
                  </Box>

                  <Box sx={{ ...labelStyle1, textAlign: "center" }}>
                    {enq?.userMobile || "-"} {/* {mobileNumber && ( */}
                    <IconButton
                      size="small"
                      sx={{ p: 0 }}
                      onClick={() =>
                        window.open(
                          `https://web.whatsapp.com/send?phone=${enq?.userMobile}`,
                          "_blank",
                        )
                      }
                    >
                      <WhatsAppIcon
                        sx={{
                          color: "white",
                          fontSize: 20,
                          borderRadius: "50%",
                          backgroundColor: "#25D366",
                          p: "3px",
                        }}
                      />
                    </IconButton>
                    {/* )} */}
                  </Box>

                  <Box
                    sx={{
                      ...labelStyle1,
                      fontWeight: "medium",
                      textAlign: "center",
                    }}
                  >
                    {enq?.userEmail || "-"}
                  </Box>

                  <Box
                    sx={{
                      ...labelStyle1,
                      textAlign: "center",
                      fontWeight: "medium",
                    }}
                  >
                    {enq?.area || "-"}
                  </Box>
                  <Box
                    sx={{
                      textAlign: "center",
                      fontWeight: "medium",
                    }}
                  >
                    <Button
                      onClick={() => {
                        setModalData(enq);
                        setOpen(true);
                      }}
                      variant="contained"
                      sx={{
                        ...labelStyle1,
                        px: { xl: 4, lg: 3, md: 3, sm: 3, xs: 3 },
                      }}
                      startIcon={
                        <Box
                          component="img"
                          src={details} // details should be the path to your image
                          alt="details"
                          sx={{
                            width: { lg: 20, md: 16, sm: 18, xs: 15 },
                            height: { lg: 20, md: 16, sm: 18, xs: 15 },
                          }}
                        />
                      }
                    >
                      Details
                    </Button>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>

        <CandidateInformation
          modalData={modalData}
          applied={true}
          open={open}
          setOpen={setOpen}
          getRecept={() => {
            // getPaymentRec({ ...getPaymentObj });
          }}
        />
      </Box>
    </>
  );
};

export default Enquiries;
